<template>
  <div class="pt-select-div" v-if="$attrs.mode == 'multiple'">
    <a-select :dropdownStyle="dropdownStyle"  :filterOption="filterOption" :dropdownMatchSelectWidth="dropdownMatchSelectWidth" :style="selectStyle" :maxTagCount="maxTagCount" @dropdownVisibleChange="dropdownVisibleChange" :allowClear="allowClear" @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder="placeholder?placeholder:$t('baseVO.selectPlaceholder')">
      <a-icon slot="suffixIcon" type="caret-down" v-if="showArrow"/>
      <span v-else slot="suffixIcon"></span>
      <slot></slot>
      <div slot="maxTagPlaceholder" v-if="$slots.maxTagPlaceholder"  >
        <slot name="maxTagPlaceholder"  ></slot>
      </div>

    </a-select>
    <a-icon class="multiple-icon" :class="open?'openClass':''" type="caret-down"></a-icon>
  </div>
  <a-select v-else :filterOption="filterOption" :allowClear="allowClear" :dropdownMatchSelectWidth="dropdownMatchSelectWidth" @change="changeValue" v-model="input" v-bind="$attrs" v-on="$listeners" :placeholder="placeholder?placeholder:$t('baseVO.selectPlaceholder')">
    <a-icon slot="suffixIcon" type="caret-down" v-if="showArrow"/>
    <span v-else slot="suffixIcon"></span>
    <slot></slot>
  </a-select>
</template>

<script>
  export default {
    name: 'ptSelect',
    props:{
      showArrow:{
        type:Boolean,
        default:true,
      },
      placeholder:{
        type:String,
      },
      dropdownMatchSelectWidth:{
        type:Boolean,
        default:true,
      },
      dropdownStyle:{
        type:String,
      },
      allowClear:{
        type:Boolean,
        default:true,
      },
      value:{
        type: [String, Number, Boolean, Object, Array],
      },
      maxTagCount:{
        type:Number,
        default:1,
      },
      selectStyle:{
        type:Object,
        default:()=>{
          return {width:'100%'}
        }
      },
    },
    data() {
      return {
        input:this.value,
        open:false,
      }
    },
    watch:{
      value (val) {
        this.input = val
      },
      input(val){
        this.$emit('input',val)
      }
    },
    methods:{
      filterOption(input, option){
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      changeValue(value){
        this.$emit('input',value)
        this.$emit('changeValue',value);
      },
      dropdownVisibleChange(open){
        this.open = open
      },
    }
  }
</script>

<style scoped lang="less">
  .pt-select-div{
    position: relative;
    width: 100%;
    /deep/ .ant-select-selection--multiple .ant-select-selection__placeholder{
      margin-left: 0px;
    }
    .multiple-icon{
      position: absolute;
      color: rgba(0, 0, 0, 0.25);
      right: 11px;
      top: 10px;
      font-size: 12px;
    }
    .openClass{
      transform: rotate(180deg);
    }
  }
</style>
